// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../reason/next/Next.bs.js");
var React = require("react");
var FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
var Sentry = require("../../reason/Sentry.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var EventLogs = require("../../reason/EventLogs.bs.js");
var LoginForm = require("./LoginForm.bs.js");
var PageTitle = require("../../reason/common/PageTitle.bs.js");
var Responsive = require("../../uikit/reason/helpers/Responsive.bs.js");
var Text__Jsx3 = require("../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var AuthSession = require("../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var PasswordInput = require("./PasswordInput.bs.js");
var SystemMessage = require("../../uikit/reason/molecules/SystemMessage/SystemMessage.bs.js");
var Form__Checkbox = require("../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var MobileInputTextSize = require("../../v5/common/Form/MobileInputTextSize.bs.js");
var EmailRegistrationStatus = require("../../v5/common/Query/EmailRegistrationStatus.bs.js");
var MarkupHelpers = require("components/MarkupHelpers");

function LoginPage(props) {
  var recordEvent = EventLogs.useRecordEvent();
  var router = Next.useRouter();
  var userRole = React.useRef(undefined);
  var nextParam = Next.Router.query(router)["next"];
  var msgParam = Next.Router.query(router)["msg"];
  var redirectRoute = function (userRole) {
    return Core__Option.getOr(nextParam, userRole === "agent" ? "/" : "/client");
  };
  React.useEffect((function () {
          if (nextParam !== undefined) {
            Next.Router.prefetch(Caml_option.valFromOption(nextParam), router);
          } else {
            Next.Router.prefetch("/", router);
            Next.Router.prefetch("/client", router);
          }
        }), [nextParam]);
  var form = LoginForm.useForm({
        email: "",
        password: "",
        rememberMe: true
      }, {
        queryEmailAddress: EmailRegistrationStatus.queryFn
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var notifyOnSuccess = param$1.notifyOnSuccess;
          AuthSession.login(Scalars.EmailAddress.toString(param.email), param.password, param.rememberMe).then(function (x) {
                if (x.TAG === "Ok") {
                  var data = x._0;
                  var match = data.user;
                  var role = match.role;
                  userRole.current = role;
                  notifyOnSuccess(undefined);
                  if (!data.impersonated) {
                    recordEvent([
                          role === "agent" ? "USER" : "CLIENT",
                          match.id
                        ], undefined, "Login", undefined);
                  }
                  return Next.Router.push(redirectRoute(role), undefined, undefined, router);
                }
                var match$1 = x._0;
                if (typeof match$1 === "object") {
                  Sentry.captureErrorMessage("Error in login response: " + match$1.VAL, true, undefined, "LoginPage.res", 63, undefined, undefined, undefined);
                  return notifyOnFailure("An error occurred while logging in. Please try again or contact support");
                } else {
                  return notifyOnFailure("Your email/password weren't recognized");
                }
              });
        }));
  var serverMessage = form.status;
  var tmp;
  tmp = typeof serverMessage !== "object" || serverMessage.TAG !== "SubmissionFailed" ? null : JsxRuntime.jsx(SystemMessage.make, {
          id: "form_submission",
          time: 5000,
          text: serverMessage._0,
          type_: "error",
          dismissible: true,
          secondary: true,
          handleOnDismiss: (function (_id) {
              form.dismissSubmissionResult();
            })
        });
  var tmp$1;
  tmp$1 = msgParam === "password_change" ? JsxRuntime.jsx(View__Jsx3.make, {
          mb: "md",
          children: Caml_option.some(JsxRuntime.jsx(SystemMessage.make, {
                    id: "login_success",
                    time: 0,
                    text: "Your password was changed successfully!",
                    type_: "success",
                    secondary: true,
                    handleOnDismiss: (function (_id) {
                        
                      })
                  }))
        }) : null;
  var match = form.emailResult;
  var tmp$2;
  if (match !== undefined && match.TAG !== "Validating") {
    var message = match._0;
    tmp$2 = message.TAG === "Ok" ? null : JsxRuntime.jsx(FormV5.$$Error.make, {
            children: message._0
          });
  } else {
    tmp$2 = null;
  }
  var match$1 = form.passwordResult;
  var tmp$3;
  tmp$3 = match$1 !== undefined && match$1.TAG !== "Ok" ? JsxRuntime.jsx(FormV5.$$Error.make, {
          children: match$1._0
        }) : null;
  return JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Login to Top Agent Network"
                    }),
                JsxRuntime.jsxs(MarkupHelpers.ContentBox, {
                      paddingFull: true,
                      hasShadow: true,
                      children: [
                        tmp,
                        tmp$1,
                        JsxRuntime.jsxs(View__Jsx3.make, {
                              children: [
                                JsxRuntime.jsx(Form__Input.make, {
                                      labelText: "Email",
                                      onChange: (function ($$event) {
                                          form.updateEmail((function (input, value) {
                                                  return {
                                                          email: value,
                                                          password: input.password,
                                                          rememberMe: input.rememberMe
                                                        };
                                                }), $$event.target.value);
                                        }),
                                      onBlur: (function (param) {
                                          form.blurEmail();
                                        }),
                                      status: Core__Option.flatMap(form.emailResult, (function (x) {
                                              if (x.TAG === "Validating") {
                                                return ;
                                              } else if (x._0.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: form.input.email
                                    }),
                                tmp$2
                              ]
                            }),
                        JsxRuntime.jsxs(View__Jsx3.make, {
                              mt: "md",
                              children: [
                                JsxRuntime.jsx(PasswordInput.make, {
                                      onBlur: (function (param) {
                                          form.blurPassword();
                                        }),
                                      onChange: (function ($$event) {
                                          form.updatePassword((function (input, value) {
                                                  return {
                                                          email: input.email,
                                                          password: value,
                                                          rememberMe: input.rememberMe
                                                        };
                                                }), $$event.target.value);
                                        }),
                                      status: Core__Option.map(form.passwordResult, (function (x) {
                                              if (x.TAG === "Ok") {
                                                return "ok";
                                              } else {
                                                return "error";
                                              }
                                            })),
                                      value: form.input.password
                                    }),
                                tmp$3
                              ]
                            }),
                        JsxRuntime.jsxs(View__Jsx3.make, {
                              mt: "md",
                              alignItems: Responsive.make("flexStart", "center", undefined, undefined, undefined, undefined, undefined),
                              justifyContent: Responsive.make("flexStart", "spaceBetween", undefined, undefined, undefined, undefined, undefined),
                              flexDirection: Responsive.make("column", "row", undefined, undefined, undefined, undefined, undefined),
                              children: [
                                JsxRuntime.jsx(Form__Checkbox.make, {
                                      onChange: (function ($$event) {
                                          $$event.preventDefault();
                                          form.updateRememberMe((function (input, value) {
                                                  return {
                                                          email: input.email,
                                                          password: input.password,
                                                          rememberMe: value
                                                        };
                                                }), !form.input.rememberMe);
                                        }),
                                      checked: form.input.rememberMe,
                                      label: "Remember me"
                                    }),
                                JsxRuntime.jsx(View__Jsx3.make, {
                                      mt: Responsive.make("sm", "zero", undefined, undefined, undefined, undefined, undefined),
                                      children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.Link.make, {
                                                href: "/reset_password",
                                                children: "Forgot your password?"
                                              }))
                                    })
                              ]
                            }),
                        JsxRuntime.jsx(View__Jsx3.make, {
                              mt: "lg",
                              justifyContent: "flexEnd",
                              children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                        disabled: !Core__Option.getOr(form.valid(), false) || form.submitting,
                                        size: "medium",
                                        children: "Sign in"
                                      }))
                            })
                      ]
                    }),
                JsxRuntime.jsx(View__Jsx3.make, {
                      pt: "lg",
                      children: Caml_option.some(JsxRuntime.jsx(Text__Jsx3.make, {
                                textAlign: "center",
                                children: JsxRuntime.jsxs("p", {
                                      children: [
                                        "Not a member?  ",
                                        JsxRuntime.jsx("a", {
                                              children: "Request membership",
                                              href: "https://www.topagentnetwork.com/request-membership"
                                            }),
                                        " or ",
                                        JsxRuntime.jsx("a", {
                                              children: "learn more",
                                              href: "https://www.topagentnetwork.com"
                                            }),
                                        "."
                                      ]
                                    })
                              }))
                    })
              ],
              className: MobileInputTextSize.className,
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  form.submit();
                })
            });
}

var View;

var responsive = Responsive.make;

var make = LoginPage;

var $$default = LoginPage;

exports.View = View;
exports.responsive = responsive;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* Next Not a pure module */
